import { render, staticRenderFns } from "./BaseReadMore.vue?vue&type=template&id=1f1d4737"
import script from "./BaseReadMore.vue?vue&type=script&lang=js"
export * from "./BaseReadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports